import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.nav `
  --fgColor: ${brand.base.blue};
  --bgColor: ${brand.primary.blueGrey};

  ${scrollbars}

  position: absolute;
  top: calc(100% - var(--headerNavHeight));
  left: 0;
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  color: var(--fgColor);
  height: calc(100vh - var(--headerHeight) + var(--headerNavHeight));
  opacity: 0;
  overflow-y: auto;
  padding: 24px var(--sitePadding);
  pointer-events: none;
  transition: opacity 0.15s ${cubicEaseOut};
  width: 100%;
  z-index: 1;

  &[data-m-active='true'] {
    opacity: 1;
    pointer-events: all;
  }
`;
const GroupList = styled.ul ``;
const Group = styled.li `
  &:not(:last-child) {
    margin-bottom: 48px;
  }
`;
const GroupTitle = styled.span `
  display: block;
  color: currentColor;
  ${fonts.apparat.semiBold};
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 24px;
  opacity: 0.5;
  text-transform: uppercase;
`;
const List = styled.ul ``;
const Item = styled.li `
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.apparat.light};
  font-size: 20px;
  line-height: 30px;
  text-decoration: none;

  ${Group} & {
    font-size: 18px;
    line-height: 28px;
  }

  ${Item}[data-summary="true"] & {
    display: block;
    font-size: 18px;
    line-height: 28px;
  }

  &:focus,
  &:hover {
    color: ${brand.base.blue};
    text-decoration: underline;
    text-underline-position: under;
  }
`;
const Text = styled.span `
  ${Item}[data-summary="true"] & {
    ${fonts.apparat.semiBold};
  }
`;
const Summary = styled.span `
  opacity: 0.5;
`;
const Arrow = styled.span `
  margin-left: auto;
`;
const Header = styled.header `
  padding-bottom: 32px;
`;
const Back = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.apparat.semiBold};
  font-size: 20px;
  line-height: 30px;
  padding: 0;

  > svg {
    margin-right: 12px;
    transform: rotate(180deg);
  }
`;
const Current = styled(Link) `
  color: ${brand.base.blue};
  text-decoration: underline;
  text-underline-position: under;
`;
const CtaWrapper = styled.div `
  display: flex;
  column-gap: var(--gutterWidth);
  justify-content: center;
  padding-top: 96px;
`;
const MemberMenu = styled.ul `
  li {
    margin-top: 24px;
  }
`;
const MemberLink = styled.a `
  ${fonts.apparat.light};
  font-size: 16px;
  line-height: 24px;
  color: currentColor;
  text-transform: capitalize;
`;
const MobileNavigationStyles = {
    Arrow,
    Back,
    Container,
    CtaWrapper,
    Current,
    Group,
    GroupList,
    GroupTitle,
    Header,
    Item,
    Link,
    List,
    MemberLink,
    MemberMenu,
    Summary,
    Text,
};
export default MobileNavigationStyles;
